<template>
    <div>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text=""
                @load="onLoad"
                :offset="100"
        >
            <div v-if="tableData.length>0" @click="contents(item)" v-for="(item,index) in tableData" :key="index"
                 class="cards">
                <div class="card_top">
                    <img src="../../assets/image/h5/word.png" alt="Word 文档">
                    <span>{{ getTitle(item) }}</span>
                </div>
                <div class="card_bottom">
                    <div class="card_bottom_left">
                        <span>{{ getAuthor(item) }}</span>
                        <span><img src="../../assets/image/h5/doc.png" alt="页数">{{ item.pages || '待确认' }} 页</span>
                    </div>
                    <div class="card_bottom_right">
                        <img src="../../assets/image/h5/bxz.png" alt="标小助">
                        标小助
                    </div>
                </div>
            </div>

            <div v-if="tableData.length<1"
                 class="phone_card_empty">
                <img src="../../assets/image/h5/empty.png" alt="暂无资料">
                <p>
                    如果您找不到资料,可以在线咨询我们,我们可以为您量身定制标书/方案</p>
                <p>
                    <a-button @click="$router.push('/phoneCustom')" type="primary">了解详情</a-button>
                </p>
            </div>

        </van-list>
    </div>
</template>

<script>
import {addViewsByUserPhone, getListByCategory} from "@/api/phone/modelTopic";
import {navigatePhoneUrl, removeEmptyField} from "@/utils/resToData";
import {parseTime} from "@/utils/parse";
import {Toast} from "vant";


export default {
    name: "card",
    props: ['searchForm', 'status'],
    data() {
        return {
            img: require('../../assets/image/h5/empty.png'),
            form: {
                pageNum: 1,
                pageSize: 10,
                bidType: 0,
                categoryId: '',
                keyWord: '',
                maxPage: '',
                minPage: '',
                type: 0
            },
            totalCount: 0,
            loading: false,
            finished: false,
            tableData: []
        }
    },

    mounted() {
        // this.getByCategory(this.form)
        this.$bus.$on('cardInfo', data => {
            this.form.pageNum = 1
            this.tableData = []
            this.getByCategory(data)
            this.finished = false
            this.form = data
        })
    },

    destroyed() {
        this.$bus.$off('cardInfo')
    },

        methods: {
        getTitle(item) {
            const title = item && item.title ? item.title : '未命名资料'
            return title.length > 18 ? title.slice(0, 18) + '...' : title
        },
        getAuthor(item) {
            const author = item && item.author ? item.author : '标书资料'
            return author.length > 9 ? author.slice(0, 9) : author
        },
        contents(item) {
            sessionStorage.removeItem('historyUrls')
            navigatePhoneUrl('/phoneContent', {doc: item.id})

            // this.$router.push('/phoneContent')
        },

        onLoad() {
            setTimeout(() => {
                this.loading = false;
                if (this.form.pageNum < this.totalCount) {
                    if (this.form.pageNum > 1) {
                        this.getByCategory(this.form)
                    }
                    this.form.pageNum += 1
                } else if (this.form.pageNum === this.totalCount) {
                    if (this.form.pageNum > 1) {
                        this.getByCategory(this.form)
                    }
                    this.finished = true;
                }
            }, 800)

        },

        getByCategory(data) {
            const toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });

            getListByCategory(removeEmptyField(data)).then(res => {
                Toast.clear();
                this.totalCount = Math.ceil(res.totalCount / 10)
                if (res.totalCount > 0) {
                    res.H5BidList.forEach(value => {
                        value.createTime = parseTime(value.createTime)
                    })

                    this.tableData.push(...res.H5BidList)
                } else {
                    this.tableData = []
                }

            }).catch(err => {
            })
        },
    },

    watch: {
        searchForm(newValue, oldValue) {
            this.finished = false
            this.tableData = []
            this.form = newValue
            this.getByCategory(newValue)
        }
    }
}
</script>

<style scoped lang="scss">
.cards {
  margin-bottom: 0.1rem;
  width: 100%;
  min-height: 1.02rem;
  background: #FFFFFF;
  box-shadow: 0 0.06rem 0.16rem rgba(17, 24, 39, 0.04);
  border: 1px solid #e5e7eb;
  border-radius: 0.14rem;
  padding: 0.15rem;
  box-sizing: border-box;

  .card_top {
    height: 0.36rem;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 0 0.1rem 0;
    box-sizing: border-box;
    border-bottom: 1px solid #F3F4F6;

    img {
      height: 0.16rem;
    }

    span {
      font-size: 0.16rem;
      color: #111827;
      font-weight: 700;
      margin-left: 0.1rem;
    }
  }

  .card_bottom {
    height: 0.36rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.22rem 0;
    box-sizing: border-box;

    .card_bottom_left {
      color: #999999;
      font-size: 0.14rem;
      display: flex;
      align-items: center;
      min-width: 0;

      span {
        margin-right: 0.12rem;

        img {
          height: 0.14rem;
        }
      }
    }

    .card_bottom_right {
      width: 1rem;
      display: flex;
      align-items: center;
      justify-content: right;
      color: #999999;
      font-size: 0.12rem;

      img {
        height: 0.14rem;
      }
    }
  }
}

.phone_card_empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 3rem;
  padding: 0.24rem 0.1rem;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.14rem;

  img {
    width: 1.2rem;
  }

  p {
    width: 100%;
    margin: 0.12rem 0 0;
    color: #6b7280;
    font-size: 0.13rem;
    line-height: 1.7;
    text-align: center;
  }

  .ant-btn {
    width: 0.98rem;
    height: 0.34rem;
    border-radius: 0.1rem;
  }
}

</style>
